module.exports = __webpack_public_path__ + "slack-1-fcdfe57a9723a565224d7e55ed96258c.webp";